var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventTrailCancelledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_3442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H51V51H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_3442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8119 46.0195H2.98769C1.89229 46.0195 0.995605 45.1231 0.995605 44.0273V7.96865C0.995605 6.87294 1.89199 5.97646 2.98769 5.97646H42.8315C43.9272 5.97646 44.8236 6.87314 44.8236 7.96865V30.9417",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.957 9.96068C9.5874 9.96068 8.4668 8.84007 8.4668 7.47044V3.48607C8.4668 2.11644 9.5874 0.995834 10.957 0.995834C12.3267 0.995834 13.4473 2.11644 13.4473 3.48607V5.47826",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9097 9.96068C21.54 9.96068 20.4194 8.84007 20.4194 7.47044V3.48607C20.4194 2.11644 21.54 0.995834 22.9097 0.995834C24.2793 0.995834 25.3999 2.11644 25.3999 3.48607V5.47826",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8633 9.96068C33.4937 9.96068 32.373 8.84007 32.373 7.47044V3.48607C32.373 2.11644 33.4937 0.995834 34.8633 0.995834C36.2328 0.995834 37.3534 2.11644 37.3534 3.48607V5.47826",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49365 13.9451H44.3257",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6323 18.9257V41.039",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.771 18.9257V41.039",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9097 18.9257V41.039",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0483 18.9257V31.4639",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.187 18.9249V26.9662",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97607 23.3279H39.8433",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97607 29.9824H30.3865",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97607 36.6369H26.5174",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.043 50.0039C45.5293 50.0039 50.0039 45.5293 50.0039 40.043C50.0039 34.5566 45.5293 30.082 40.043 30.082C34.5567 30.082 30.082 34.5566 30.082 40.043C30.082 45.5293 34.5567 50.0039 40.043 50.0039Z",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0313 37.0548L37.0547 43.0313",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0547 37.0548L43.0313 43.0313",
    stroke: "#FF0E12",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTrailCancelledIcon);
export default __webpack_public_path__ + "static/media/eventTrailCancelledIcon.03f10bd470b03f3c67461f3090df4cc9.svg";
export { ForwardRef as ReactComponent };